(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  // Keep the navbar search fully inline: never let Enter or the search
  // button navigate to a /search results page. Results stay in the
  // live, scrollable predictive-search dropdown.
  document.querySelectorAll('.header__inline-search form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });
  });

      // Filter predictive search results by the selected category dropdown
  document.querySelectorAll('.header__inline-search form').forEach(function (form) {
    var select = form.querySelector('select[name="options[category]"]');
    var predictiveEl = form.closest('predictive-search');
    if (!select || !predictiveEl) return;

    function applyCategoryFilter() {
      var category = select.value;
      var list = form.querySelector('#predictive-search-results-products-list');
      var noResultsEl = form.querySelector('.predictive-search__no-results');
      if (!list) return;

      var visibleCount = 0;
      list.querySelectorAll('.predictive-search__list-item').forEach(function (item) {
        var collections = (item.getAttribute('data-collections') || '').split(',');
        var matches = !category || collections.indexOf(category) !== -1;
        item.style.display = matches ? '' : 'none';
        if (matches) visibleCount++;
      });

      if (noResultsEl) {
        noResultsEl.hidden = visibleCount > 0;
      }

      var countEl = form.querySelector('.predictive-search__results-count');
      if (countEl) {
        countEl.textContent = window.chitsPlural ? window.chitsPlural(window.chitsStrings.results, visibleCount) : visibleCount + (visibleCount === 1 ? ' result' : ' results');
      }
    }

    select.addEventListener('change', applyCategoryFilter);

    // Fires once per new result set, instead of watching the whole subtree
    new MutationObserver(applyCategoryFilter).observe(predictiveEl, {
      attributes: true,
      attributeFilter: ['results'],
    });
  });

  document.querySelectorAll('.header__menu-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var panel = btn.nextElementSibling;
        panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', panel.classList.contains('is-open'));
      });
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.header__menu-panel.is-open').forEach(function (panel) {
        if (!panel.parentElement.contains(e.target)) {
          panel.classList.remove('is-open');
        }
      });
    });

    /* collection row: show ‹ › arrows only when there's more to scroll */
    document.querySelectorAll('[data-cat-track]').forEach(function (track) {
      var row = track.querySelector('.header__category-scroll');
      var prev = track.querySelector('.header__cat-arrow--prev');
      var next = track.querySelector('.header__cat-arrow--next');
      if (!row || !prev || !next) return;

      function update() {
        var max = row.scrollWidth - row.clientWidth;
        var canLeft = row.scrollLeft > 4;
        var canRight = row.scrollLeft < max - 4;
        prev.hidden = !canLeft;
        next.hidden = !canRight;
        track.classList.toggle('can-left', canLeft);
        track.classList.toggle('can-right', canRight);
      }

      function go(dir) {
        row.scrollBy({ left: dir * row.clientWidth * 0.7, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
